import React, { useEffect, useState } from 'react';
import { WarningIcon } from './Icons';
function getSecondsUntilMidnightEST(): number {
  const now = new Date();
  const estString = now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  });
  const estNow = new Date(estString);
  const midnight = new Date(estNow);
  midnight.setHours(24, 0, 0, 0);
  return Math.max(0, Math.floor((midnight.getTime() - estNow.getTime()) / 1000));
}
export const UrgencyBar = () => {
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilMidnightEST());
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilMidnightEST());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 bg-brand-crimson text-white py-3 px-4 shadow-md" data-id="element-207">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-center text-sm md:text-base font-medium" data-id="element-208">
        <div className="flex items-center gap-2" data-id="element-209">
          <WarningIcon className="w-5 h-5 flex-shrink-0" data-id="element-210" />
          <span data-id="element-211">
            ATENCIÓN: La oferta de lanzamiento con 15 Bonos de Regalo expira
            cuando el contador llegue a cero.
          </span>
        </div>
        <div className="font-bold bg-white/20 px-3 py-1 rounded-md tracking-wider" data-id="element-212">
          [{formatTime(timeLeft)}]
        </div>
      </div>
    </div>;
};